import { Module } from "vuex";

import { RootStateType } from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import { MessageState } from "./model";

let state: MessageState = {
  message: {
    id: '',
    createdAt: '',
    dataImplementationId: ''
  },
  messages: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<MessageState, RootStateType>;
